import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import EnterpriseNavigation from './components/Layout/EnterpriseNavigation';

// Dashboard imports
import ExecutiveDashboard from './pages/dashboards/ExecutiveDashboard';
import OrdersDashboard from './pages/dashboards/OrdersDashboard';
import SupplyChainDashboard from './pages/dashboards/SupplyChainDashboard';
import ComplianceDashboard from './pages/dashboards/ComplianceDashboard';
import FinancialDashboard from './pages/dashboards/FinancialDashboard';
import InventoryDashboard from './pages/dashboards/InventoryDashboard';

// Catalog imports
import Catalog from './pages/catalog/Catalog';

// Inventory imports
import StockLevels from './pages/inventory/StockLevels';
import ExpiryManagement from './pages/inventory/ExpiryManagement';

// Orders imports
import OrderManagement from './pages/orders/OrderManagement';

// Supply Chain imports
import SupplyChain from './pages/supply-chain/SupplyChain';
import PurchaseOrders from './pages/supply-chain/PurchaseOrders';
import Procurement from './pages/supply-chain/Procurement';
import StockTransfer from './pages/supply-chain/StockTransfer';

// Compliance imports
import S8Register from './pages/compliance/S8Register';
import Compliance from './pages/compliance/Compliance';

// Reports imports
import Analytics from './pages/reports/Analytics';
import DemographicReports from './pages/reports/DemographicReports';

// Alerts imports
import Alerts from './pages/alerts/Alerts';
import IntelligentOrderingAlerts from './pages/alerts/IntelligentOrderingAlerts';

// Invoicing imports
import InvoiceManagement from './pages/invoicing/InvoiceManagement';
import FacilityBilling from './pages/invoicing/FacilityBilling';
import PaymentTracking from './pages/invoicing/PaymentTracking';

// Utilities imports
import TestPage from './pages/utilities/TestPage';
import NavigationTest from './pages/utilities/NavigationTest';
import SimpleNavTest from './pages/utilities/SimpleNavTest';
import MinimalNavTest from './pages/utilities/MinimalNavTest';
import { AuthProvider } from './contexts/AuthContext';
import { RealtimeProvider } from './contexts/RealtimeContext';
import RealtimeNotifications from './components/RealtimeNotifications';

function App() {
  return (
    <AuthProvider>
      <RealtimeProvider>
        <Router>
          <div className="min-h-screen bg-gradient-to-br from-slate-50 to-purple-50">
            <EnterpriseNavigation />
            
            {/* Real-time Notifications */}
            <div className="fixed top-4 right-4 z-50">
              <RealtimeNotifications />
            </div>
            
            <main className="pt-14 px-6 pb-6">
                <div className="w-full">
                  <Routes>
                    {/* Dashboard Routes */}
                    <Route path="/" element={<ExecutiveDashboard />} />
                    <Route path="/dashboards" element={<ExecutiveDashboard />} />
                    <Route path="/dashboards/orders" element={<OrdersDashboard />} />
                    <Route path="/dashboards/supply-chain" element={<SupplyChainDashboard />} />
                    <Route path="/dashboards/compliance" element={<ComplianceDashboard />} />
                    <Route path="/dashboards/financial" element={<FinancialDashboard />} />
                    <Route path="/dashboards/inventory" element={<InventoryDashboard />} />
                    
                    {/* Catalog Routes */}
                    <Route path="/catalog" element={<Catalog />} />
                    <Route path="/catalog/interactions" element={<Catalog />} />
                    <Route path="/catalog/pbs" element={<Catalog />} />
                    
                    {/* Inventory Routes */}
                    <Route path="/inventory" element={<StockLevels />} />
                    <Route path="/inventory/expiry" element={<ExpiryManagement />} />
                    
                    {/* Orders Routes */}
                    <Route path="/orders" element={<OrderManagement />} />
                    
                    {/* Supply Chain Routes */}
                    <Route path="/supply-chain" element={<SupplyChain />} />
                    <Route path="/supply-chain/purchase-orders" element={<PurchaseOrders />} />
                    <Route path="/supply-chain/procurement" element={<Procurement />} />
                    <Route path="/supply-chain/transfers" element={<StockTransfer />} />
                    
                    {/* Invoicing Routes */}
                    <Route path="/invoicing" element={<InvoiceManagement />} />
                    <Route path="/invoicing/facilities" element={<FacilityBilling />} />
                    <Route path="/invoicing/payments" element={<PaymentTracking />} />
                    
                    {/* Reports Routes */}
                    <Route path="/reports" element={<DemographicReports />} />
                    <Route path="/reports/demographics" element={<DemographicReports />} />
                    <Route path="/reports/financial" element={<Analytics />} />
                    <Route path="/reports/operational" element={<Analytics />} />
                    
                    {/* Alerts Routes */}
                    <Route path="/alerts" element={<Alerts />} />
                    <Route path="/alerts/ordering" element={<IntelligentOrderingAlerts />} />
                    <Route path="/alerts/history" element={<Alerts />} />
                    
                    {/* Compliance Routes */}
                    <Route path="/compliance" element={<Compliance />} />
                    <Route path="/compliance/s8-register" element={<S8Register />} />
                    <Route path="/compliance/audit" element={<Compliance />} />
                    
                    {/* Test Routes */}
                    <Route path="/test" element={<TestPage />} />
                    <Route path="/nav-test" element={<NavigationTest />} />
                    <Route path="/simple-nav-test" element={<SimpleNavTest />} />
                    <Route path="/minimal-nav-test" element={<MinimalNavTest />} />
                  </Routes>
            </div>
          </main>
        </div>
      </Router>
    </RealtimeProvider>
    </AuthProvider>
  );
}

export default App;